import React from 'react';
import { useSelector } from 'react-redux';
import find from 'lodash/find';

import * as selectors from '@src/store/selectors';
import AppBackground from '@src/components/AppBackground';
import ScrollToTop from '@src/components/scrollToTop';
import ModalContainer from '@src/components/modalContainer';
import { colorThemes } from '@src/const/theme';

const App = ({ children }) => {
	const theme = useSelector(selectors.getThemeSelector);
	const selectedColorTheme = theme?.themes?.color_theme;
	const colorTheme = find(colorThemes, { id: selectedColorTheme }) || colorThemes[0];
	const { colors } = colorTheme;
	const cssVariablesStyle = Object.keys(colors)
		.map(colorKey => `--${colorKey}: ${colors[colorKey]};`)
		.join('');

	return (
		<>
			<style global jsx>
				{`
          :root {
            ${cssVariablesStyle}
          }
        `}
			</style>
			<ScrollToTop>
				<AppBackground>
					{children}
					<ModalContainer />
				</AppBackground>
			</ScrollToTop>
		</>
	);
};

export default App;
